import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import SectionCard from '../../../positionTemplate/components/SectionCard';
import { getId, toIds } from '../../helpers';
import EntityChipsField from '../EntityChipsField';
import SaveStatusIndicator from '../SaveStatusIndicator';
import SectionTitle from '../SectionTitle';

const titleRowSx = { alignItems: 'center', display: 'flex', gap: '12px' };

const contentSx = { padding: '8px 0' };

const DepartmentsCard = ({ positionTemplate, saveField, getStatus }) => {
  const intl = useIntl();
  const corporationId = getId(positionTemplate.corporation);

  const buildDepartmentSearch = useCallback(
    (searchTerm) => ({
      corporation: corporationId,
      filters: searchTerm ? [{ field: 'name', operation: 'icontains', value: searchTerm }] : [],
    }),
    [corporationId]
  );

  return (
    <SectionCard
      header={
        <Box sx={titleRowSx}>
          <SectionTitle>{intl.formatMessage({ id: 'pt.detail.departments.title' })}</SectionTitle>
          <SaveStatusIndicator status={getStatus('departments')} />
        </Box>
      }
    >
      <Box sx={contentSx}>
        <EntityChipsField
          testId="pt-detail-add-department"
          entities={positionTemplate.departments}
          placeholder={intl.formatMessage({ id: 'pt.detail.departments.search' })}
          route="corporations/departments/read"
          buildRequestData={buildDepartmentSearch}
          onSave={(departments) =>
            saveField({
              key: 'departments',
              fields: { departments: toIds(departments) },
              patch: { departments },
            })
          }
        />
      </Box>
    </SectionCard>
  );
};

DepartmentsCard.propTypes = {
  positionTemplate: PropTypes.shape({
    corporation: PropTypes.shape({}),
    departments: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default DepartmentsCard;
